export default {
  // calendly: { name: 'calendly', category: 'app' },
  prestashop: { name: 'prestashop', category: 'app' },
  shopify: { name: 'shopify', category: 'app' },
  // zapier: { name: 'zapier', category: 'app' },
}
